<template>
  <div>
    <!-- <PreLoading v-if="!loading" /> -->
    <CRow>
      <CCol
        md="12"
        lg="12"
      >
        <CCard>
          <CCardBody>
            <h4 class="sub-title">会員バーコード</h4>
            <transition name="slide">
              <CRow
                class="my-3"
                v-if="userCardName"
              >
                <CCol
                  sm="11"
                  md="11"
                  lg="4"
                >
                  <span>ご本人様: <strong>{{ userCardName }}</strong> 様</span>
                  <!-- PC版 -->
                  <VueBarcode
                    class="d-sm-down-none"
                    :value="userCardId"
                    format="CODE39"
                    width="1.7"
                    height="50"
                  >
                    読み込みに失敗しました
                  </VueBarcode>

                  <!-- スマホ版表示 -->
                  <VueBarcode
                    class="d-md-none"
                    :value="userCardId"
                    format="CODE39"
                    width="1"
                    height="50"
                    fontSize="15"
                  >
                    読み込みに失敗しました
                  </VueBarcode>

                  <!-- TODO: 家族会員バーコード表示 -->
                  <div
                    v-for="family in families"
                    :key="family"
                    class="my-3"
                  >
                    <span>お連れ様:
                      <strong>{{
                        family.relative.familyName +
                        " " +
                        family.relative.givenName
                      }}</strong>
                      様
                    </span>

                    <!-- PC版表示 -->
                    <VueBarcode
                      class="d-sm-down-none"
                      :value="family.relative.cardId"
                      format="CODE39"
                      width="1.7"
                      height="50"
                    >
                      読み込みに失敗しました
                    </VueBarcode>

                    <!-- スマホ版表示 -->
                    <VueBarcode
                      class="d-md-none"
                      :value="family.relative.cardId"
                      format="CODE39"
                      width="1"
                      height="50"
                      fontSize="15"
                    >
                      読み込みに失敗しました
                    </VueBarcode>
                  </div>

                  <!-- PC版表示 -->
                  <CButton
                    type="button"
                    class="px-4 d-sm-down-none center"
                    size="sm"
                    color="primary"
                    @click="onUserBarcodePreviewModal()"
                  >
                    印刷プレビュー
                  </CButton>
                </CCol>
              </CRow>
            </transition>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <h4 class="sub-title mb-4">獲得済みクーポン</h4>
            <CRow>
              <CCol md="12">
                <div class="user-info-table">
                  <CRow
                    class="r-content pl-5 mb-2"
                    v-for="coupon in coupons"
                    :key="coupon"
                  >
                    <CCol
                      sm="8"
                      md="10"
                      lg="10"
                      class="home-pointList mr-4"
                    >
                      <!-- TODO: 有効期間判定 -->

                      <CRow>
                        <CCol
                          lg="3"
                          class="title"
                        >{{ coupon.name }}</CCol>
                        <CCol
                          lg="2"
                          class=" py-2"
                        >
                          <!-- PC版表示 -->
                          <CButton
                            type="button"
                            class="d-sm-down-none"
                            size="sm"
                            color="primary"
                            @click="onCouponPreviewModal(coupon.id)"
                          >印刷プレビュー</CButton>

                          <!-- スマホ版表示 -->
                          <CButton
                            type="button"
                            class="d-md-none"
                            size="sm"
                            color="primary"
                            @click="onQRCodeClick(coupon.id)"
                          >QRコード表示</CButton>
                        </CCol>
                        <CCol
                          lg="7"
                          class="border-left"
                        >
                          {{coupon.description}}
                        </CCol>
                      </CRow>

                    </CCol>
                  </CRow>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <h4 class="sub-title mb-3">キャンペーン情報</h4>
            <ul v-if="getCampaignsDescriptioin">
              <li>クーポンを獲得する場合、バナーを選択してください</li>
              <li>
                クーポンを変更する場合、獲得済みのクーポンを一度破棄した上で、もう一度獲得する必要があります
              </li>
            </ul>
            <transition name="fade">
              <CRow v-if="campaignsNotFoundMessage">
                <CCol lg="6">
                  <CAlert color="danger">現在掲載中のクーポンはありません。</CAlert>
                </CCol>
              </CRow>
            </transition>
            <div
              v-for="campaign in campaigns"
              :key="campaign"
            >
              <CRow class="row d-flex justify-content-center">
                <div
                  class="campaign_link m-2"
                  @click="onBannerClick(campaign.id)"
                >
                  <CImg
                    fluid
                    :src="campaign.picture"
                    :align="center"
                  />
                </div>
              </CRow>
              <br />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <!-- NOTE: 10/31オープン時は非表示 -->
    <CRow class="d-sm-down-none d-md-none">
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <h4 class="sub-title mb-4">ポイント更新履歴</h4>
            <MainChart />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="qr"></div>

    <CModal
      color="info"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="userBarcodeModal"
    >
      <div ref="barcord_printsection">
        <div class="print-to-paper user-info-table">
          <div class="printThis">
            <div class="MyModal_br">
              <div class="logo_section">
                <img
                  class="m-3"
                  src="@/assets/icons/LR_logo.svg"
                  alt=""
                />
              </div>
              <div class="content_section">
                <!-- <strong>会員バーコード</strong> -->
                ご本人様: {{ getFullName(user) }} 様
                <VueBarcode
                  :value="userCardId"
                  format="CODE39"
                  width="2"
                  height="70"
                >
                  読み込みに失敗しました
                </VueBarcode>
              </div>
            </div>
          </div>
        </div>

        <!-- 家族会員バーコード表示 -->
        <div
          v-for="family in families"
          :key="family"
        >
          <div class="print-to-paper user-info-table">
            <div class="printThis">
              <div class="MyModal_br">
                <div class="logo_section">
                  <img
                    class="m-3"
                    src="@/assets/icons/LR_logo.svg"
                    alt=""
                  />
                </div>
                <div class="content_section">
                  <!-- <strong>家族会員バーコード</strong> -->
                  お連れ様: {{ getFullName(family.relative) }} 様
                  <VueBarcode
                    :value="family.relative.cardId"
                    format="CODE39"
                    width="2"
                    height="70"
                  >
                    読み込みに失敗しました
                  </VueBarcode>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #header> 会員バーコード印刷 </template>
      <template #footer>
        <CButton
          @click="userBarcodeModal = false"
          color="secondary"
        ><i class="icon cil-x"></i> 閉じる</CButton>
        <CButton
          @click="print('barcord_printsection')"
          color="success"
        >
          印刷</CButton>
      </template>
    </CModal>

    <!-- PC版 クーポンQRコード表示 -->
    <CModal
      color="info"
      size="lg"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="couponPreviewModal"
    >
      <ul v-if="activatedOptions">
        <li>クーポンご利用の際は、スマートフォンにて本画面をご提示ください</li>
        <li>
          スマートフォンでの表示が難しい場合、本画面を印刷してご持参ください
        </li>
        <li>
          クーポンを変更する場合、獲得済みのクーポンを一度破棄した上で、もう一度獲得する必要があります
        </li>
      </ul>
      <div class="coupon_list_section">
        <div ref="coupon_printsection">
          <div
            class="print-margin"
            v-for="activatedOption in activatedOptions"
            :key="activatedOption"
          >
            <div class="print-to-paper user-info-table">
              <div
                id="printThis"
                ref="printsection"
              >
                <div id="MyModal">
                  <div class="logo-p">
                    <img
                      src="@/assets/icons/LR_logo.svg"
                      alt=""
                    />
                  </div>

                  <div class="left-s">
                    <ul class="cupon-list-info">
                      <li>
                        <strong></strong>
                        <h1>{{ activatedOption.shortCode }}</h1>
                      </li>
                      <li>
                        <strong>クーポン名</strong>
                        <span>{{ activatedOption.name }}</span>
                      </li>
                      <li>
                        <strong>オプション名</strong>
                        <span>{{ activatedOption.optionName }}</span>
                      </li>
                      <li>
                        <strong>オプション説明</strong>
                        <span>{{ activatedOption.optionDescription }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="right-s coupon-qr-s">
                    <h4>QRコード</h4>

                    <VueQrcode
                      :value="activatedOption.shortCode"
                      :options="option"
                      tag="img"
                    ></VueQrcode>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #header>
        <h6 class="modal-title">獲得済みクーポン</h6>
      </template>
      <template #footer>
        <CButton
          @click="closeActivatedOptionsModal()"
          color="secondary"
        >
          <i class="icon cil-x"></i> 閉じる
        </CButton>
        <CButton
          @click="print('coupon_printsection')"
          color="success"
        >
          印刷</CButton>
        <CButton
          @click="onReleaseCouponClick('PC')"
          color="danger"
        >
          <i class="icon cil-trash"></i> クーポンを破棄する
        </CButton>
      </template>
    </CModal>

    <!-- スマホ版 クーポンQRコード表示 -->
    <CModal
      :show.sync="qrModel"
      :closeOnBackdrop="false"
      :centered="true"
      color="info"
      size="sm"
    >
      <p>クーポンご利用の際は、本画面をご提示ください。</p>
      <p>
        クーポンを変更する場合、獲得済みのクーポンを一度破棄した上で、もう一度獲得する必要があります。
      </p>
      <div class="user-info-table">
        <div id="MySPModal">
          <div
            class="show_section m-2"
            v-for="activatedOption in activatedOptions"
            :key="activatedOption"
          >
            <ul class="list_k">
              <li>
                <h1 class="text-center">{{ activatedOption.shortCode }}</h1>
              </li>
              <li>
                <strong class="mr-2">クーポン名</strong>
                <span>{{ activatedOption.name }}</span>
              </li>
              <li>
                <strong class="mr-2">オプション名</strong>
                <span>{{ activatedOption.optionName }}</span>
              </li>
              <li>
                <strong class="mr-2">オプション説明</strong>
                <span>{{ activatedOption.optionDescription }}</span>
              </li>
            </ul>
            <div class="sp_coupon">
              <!-- :value="activatedOption.qrcode" -->
              <VueQrcode
                :value="activatedOption.shortCode"
                :options="option"
                tag="img"
              ></VueQrcode>
            </div>
            <br />
          </div>
        </div>
      </div>
      <template #header>
        <h6 class="modal-title">獲得済みクーポン</h6>
      </template>
      <template #footer>
        <CButton
          @click="closeActivatedOptionsModal()"
          color="secondary"
        ><i class="icon cil-x"></i> 閉じる</CButton>
        <CButton
          @click="onReleaseCouponClick('Phone')"
          color="danger"
        >
          <i class="icon cil-trash"></i> クーポンを破棄する
        </CButton>
      </template>
    </CModal>

    <!-- PC版 獲得済みクーポン破棄 -->
    <CModal
      :show.sync="confirmDeleteActivatedOptionsModalPC"
      :centered="true"
      color="danger"
      size="xl"
    >
      <template #header>
        <h6 class="modal-title">クーポン破棄確認</h6>
      </template>
      表示中のクーポンを破棄します。<br />
      よろしいですか？<br />
      <template #footer>
        <CButton
          @click="closeConfirmDeleteActivatedOptionsModal()"
          color="secondary"
        ><i class="icon cil-x"></i> 閉じる</CButton>
        <CButton
          @click="onRunReleaseCouponClick(modalCouponId)"
          color="danger"
        ><i class="icon cil-trash"></i> 破棄する</CButton>
      </template>
    </CModal>

    <!-- スマホ版 獲得済みクーポン破棄 -->
    <CModal
      :show.sync="confirmDeleteActivatedOptionsModalPhone"
      :centered="true"
      color="danger"
      size="sm"
    >
      <template #header>
        <h6 class="modal-title">クーポン破棄確認</h6>
      </template>
      表示中のクーポンを破棄します。<br />
      よろしいですか？<br />
      <template #footer>
        <CButton
          @click="closeConfirmDeleteActivatedOptionsModal()"
          color="secondary"
        ><i class="icon cil-x"></i> 閉じる</CButton>
        <CButton
          @click="onRunReleaseCouponClick(modalCouponId)"
          color="danger"
        ><i class="icon cil-trash"></i> 破棄する</CButton>
      </template>
    </CModal>

    <!-- alert -->
    <CModal
      :show.sync="wargingModal"
      :centered="true"
      color="warning"
    >
      <template #header>
        <h6 class="modal-title">獲得済みクーポン</h6>
      </template>
      <p>クーポンを変更する場合、獲得済みのクーポンを一度破棄した上で、もう一度獲得してください。</p>
      <template #footer>

        <CButton
          @click="wargingModal = false"
          color="secondary"
        ><i class="icon cil-x"></i> 閉じる</CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
import axios from "axios";
import MainChart from "../components/chart";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import VueBarcode from "vue-barcode";
import { required, numeric, minLength } from "vuelidate/lib/validators";
const COUPON_STATUS = {
  INVALID: 0, // 無効
  READY: 1, // 掲載準備
  BEING_PUBLISHED: 10, // 掲載中
  BEING_PUBLISHED_ENDED: 20, // 掲載完了
  ENDED: 99, // イベント終了
  ABOLISHED: 100, // 削除(リストに表示しない)
};

export default {
  name: "Dashboard",
  components: { MainChart, VueQrcode, VueBarcode },
  data() {
    return {
      loading: false,
      couponPreviewModal: false,
      wargingModal: false,
      qrModel: false,
      userBarcodeModal: false,
      confirmDeleteActivatedOptionsModalPC: false,
      confirmDeleteActivatedOptionsModalPhone: false,
      campaignsNotFoundMessage: false,
      getCampaignsDescriptioin: false,

      loadingsvg: require("../assets/loading.svg"),

      inputText: "",
      targetText: "",
      userCardId: "",
      userCardName: "",
      families: [{ cardId: "", relative: {} }],

      option: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 0,
        scale: 0,
        width: 300,
        color: {
          dark: "#000000",
        },
      },

      collapseDuration: 0,
      printCoupon: {
        id: "",
        userid: "",
        coupon: {
          id: "",
          coupon: {
            id: "",
            sku: "",
            name: "",
            description: "",
          },
          sku: "",
          name: "",
          description: "",
        },
      },
      tableSorter: {
        column: "id",
        asc: false,
      },

      coupons: [],
      campaigns: [],
      activatedOptions: [],
      modalCouponId: "",

      user: { address: {}, points: {} },
       

    };
  },

  validations() {
    return {
      userCardId: { required, numeric, minLength: minLength(16) },
    };
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      var urlRequest = "/rest/currentuser";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;

          console.log("this.user");
          console.log(this.user);

          this.userCardId = this.user.cardId;
          this.userCardName = this.user.familyName + " " + this.user.givenName;
          // this.getFullName();
          this.getFamilies();

          this.loading = true;
        })
        .catch((err) => {
           

          console.log(err);
        });
    },

    /**
     * 全家族会員の取得
     */
    getFamilies() {
      // var urlRequest = "/rest/users/" + this.gUserName + "/relative";
      var urlRequest = "/rest/users/" + this.user.name + "/relative";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Families get: ");
          console.log(resp.data);
          this.families = [];
          this.families = resp.data;
          // this.getFullName();
        })
        .catch((err) => {
           

          console.log("Families get error: " + err);
          this.errors = err;
        });
    },

    /**
     * キャンペーン情報(クーポン)一覧を取得
     */
    getCampaigns: function () {
      const targetStatus = "10";
      // var urlRequest = "/rest/coupon";
      // var urlRequest = "/rest/coupon?status=" + targetStatus;
      var urlRequest = `/rest/coupon?status=${targetStatus}&username=${this.$keycloak.userName}`;

      this.loading = false;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.campaigns = [];
          this.campaigns = resp.data.filter((a) => {
            // 画像有り、オプション有り、掲載中ステータス のみ表示
            return (
              a.picture !== null &&
              a.options.length > 0 &&
              a.status === COUPON_STATUS.BEING_PUBLISHED
            );
          });

          if (this.campaigns.length === 0) {
            this.campaignsNotFoundMessage = true;
          } else {
            this.getCampaignsDescriptioin = true;
          }

          this.loading = true;

          console.log("this.campaigns");
          console.log(this.campaigns);
        })
        .catch((err) => {
           

          console.log(err);
          this.loading = false;
        });
    },

    /**
     * 獲得済みクーポン一覧を取得
     */
    getCoupons: function () {
      // NOTE: APIは、COUPON_TICKET_STATUS_VALID=1 のチケットのみ返却
      var urlRequest = "/rest/users/" + this.$keycloak.userName + "/coupons";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.coupons = resp.data;
          console.log("Coupon Data:" + JSON.stringify(this.coupons));
          console.log(this.coupons);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * 獲得済みクーポンのオプションリストを取得
     */
    getCouponOptions: function (couponId) {
      var urlRequest =
        "/rest/users/" + this.$keycloak.userName + "/coupons/" + couponId;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.activatedOptions = resp.data;

          this.activatedOptions.forEach((a) => {
            const jsonQr = {
              id: encodeURI(a.id),
              shortCode: encodeURI(a.shortCode),
              value: encodeURI(a.value),
              optionDescription: encodeURI(a.optionDescription),
              description: encodeURI(a.description),
            };
            a.qrcode = JSON.stringify(jsonQr);
          });

          console.log(this.activatedOptions);
          this.modalCouponId = couponId;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onCouponPreviewModal: function (couponId) {
      console.log("couponId: " + couponId);
      this.getCouponOptions(couponId);
      this.couponPreviewModal = true;
    },

    onQRCodeClick: function (couponId) {
      console.log("couponId: " + couponId);
      this.getCouponOptions(couponId);
      this.qrModel = true;
    },

    print: function (rek) {
      this.$print(this.$refs[rek]);
    },

    onUserBarcodePreviewModal: function () {
      this.userBarcodeModal = true;
    },

    onBannerClick: function (couponId) {
      console.log("onBannerClick couponId:");
      console.log(couponId);

      const activatedCoupon = this.coupons.filter((a) => a.id === couponId);
      // NOTO: オープン記念はどちらか一方のクーポンのみ獲得可能のため、
      //       取得済みクーポンがある場合は他のクーポンの獲得を不可とした。
      //       →2020/10/31 同日のみ再取得不可能に修正
      // const activatedCoupon = this.coupons;
      if (activatedCoupon.length > 0) {
        this.wargingModal = true;
        // alert(
        //   "すでに獲得済みのクーポンです。クーポンを変更する場合、獲得済みのクーポンを一度破棄した上で、もう一度獲得してください。"
        // );
        return;
      }

      this.goToCopuonActivatePage(couponId);
    },

    // go to member edit page with params
    goToCopuonActivatePage(couponId) {
      this.$router.push({
        name: "クーポン獲得",
        params: {
          userName: this.$keycloak.userName,
          couponId: couponId,
          status: "active-user",
        },
      });
    },

    /**
     * 獲得済みクーポンが1件以上あるか
     */
    hasActivatedCoupons() {
      return this.coupons.length > 0;
    },

    getFullName: function (person) {
      return person.familyName + " " + person.givenName;
    },

    /**
     * クーポンを破棄する
     */
    onReleaseCouponClick(type) {
      if (type === "PC") {
        this.confirmDeleteActivatedOptionsModalPC = true;
      }
      if (type === "Phone") {
        this.confirmDeleteActivatedOptionsModalPhone = true;
      }
    },

    /**
     * クーポンを破棄する実行クリック
     */
    onRunReleaseCouponClick(couponId) {
      this.deleteActivatedOptions(couponId);
    },

    /**
     * 獲得クーポンの削除（すべてのオプションを削除）
     */
    deleteActivatedOptions(couponId) {
      console.log("deleteActivatedOptions: " + couponId);

      // PUT rest/users/{username}/coupons/{coupon id}/status
      const urlRequest =
        "/rest/users/" +
        this.$keycloak.userName +
        "/coupons/" +
        couponId +
        "/status";
      const data = { status: 100 }; // 破棄

      axios
        .put(urlRequest, data, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("coupon delete:");
          console.log(resp.data);

          this.modalCouponId = "";
          this.getCoupons();
          this.closeConfirmDeleteActivatedOptionsModal();
          this.closeActivatedOptionsModal();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
     * 獲得クーポン削除モーダルを閉じる
     */
    closeConfirmDeleteActivatedOptionsModal() {
      this.confirmDeleteActivatedOptionsModalPC = false;
      this.confirmDeleteActivatedOptionsModalPhone = false;
    },

    closeActivatedOptionsModal() {
      this.couponPreviewModal = false;
      this.qrModel = false;
    },
  },
  beforeMount() {
    this.getUserInformation();
    this.getCampaigns();
    this.getCoupons();
  },
};
</script>
